import React, { useEffect, useRef, useState } from "react";

export default function AnimatedCounter({
  to = 0,
  duration = 1200,
  suffix = "",
}) {
  const [value, setValue] = useState(0);
  const raf = useRef(null);

  useEffect(() => {
    let start = null;
    const startVal = 0;
    const diff = to - startVal;
    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      setValue(Math.floor(startVal + diff * progress));
      if (progress < 1) raf.current = requestAnimationFrame(step);
    };
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [to, duration]);

  return (
    <div className="text-3xl font-bold">
      {value}
      {suffix}
    </div>
  );
}
